import { slug } from "./customCalc";

export const CATEGORIES = ["Grain", "Pulses", "Protein", "Vegetables", "Oil & Fat", "Spices", "Fuel", "Dairy", "Fruit", "Snack", "Sweetener", "Recipe", "Charges", "Other"];
export const COST_MODES = ["rate", "price", "free"];

const P = (name, emoji, category, unit, cost_mode = "rate", extra = {}) => ({ name, emoji, category, unit, cost_mode, ...extra });
export const LADDOO_SUBS = [
  P("Ragi flour", "🌾", "Recipe", "g"), P("Wheat flour", "🌾", "Recipe", "g"), P("Guda / Sugar", "🍬", "Recipe", "g"),
  P("Sesame seeds", "⚪", "Recipe", "g"), P("Groundnuts", "🥜", "Recipe", "g"), P("Ghee", "🧈", "Recipe", "g"),
  P("Green cardamom powder", "🌿", "Recipe", "g"), P("Laddoo making charge", "👨‍🍳", "Recipe", "no"),
];
export const PRESETS = [
  P("Rice", "🍚", "Grain", "g", "free", { grain: true }), P("Wheat", "🌾", "Grain", "g", "free", { grain: true }),
  P("Dal (Arhar/Moong/Masoor)", "🫘", "Pulses", "g"), P("Soya", "🧆", "Protein", "g"), P("Egg", "🥚", "Protein", "no"),
  P("Vegetables", "🥬", "Vegetables", "g"), P("Leafy vegetables", "🥗", "Vegetables", "g"), P("Potato", "🥔", "Vegetables", "g"),
  P("Oil", "🛢️", "Oil & Fat", "g"), P("Masala & Salt", "🧂", "Spices", "unit"), P("Turmeric", "🟡", "Spices", "g"),
  P("Fuel (LPG/Wood)", "🔥", "Fuel", "unit"), P("Milk", "🥛", "Dairy", "ml"), P("Curd", "🥣", "Dairy", "g"),
  P("Fruit (Banana)", "🍌", "Fruit", "no"), P("Chikki", "🥜", "Snack", "no"), P("Jaggery (Guda)", "🍯", "Sweetener", "g"),
  P("Sugar", "🍬", "Sweetener", "g"), P("Ghee", "🧈", "Oil & Fat", "g"), P("Ragi flour", "🌾", "Grain", "g"),
  P("Wheat flour", "🌾", "Grain", "g"), P("Millets (Jowar/Bajra)", "🌾", "Grain", "g"), P("Sesame seeds", "⚪", "Other", "g"),
  P("Groundnuts", "🥜", "Other", "g"), P("Green cardamom powder", "🌿", "Spices", "g"), P("Khichdi mix", "🍲", "Grain", "g"),
  P("Sprouts", "🌱", "Protein", "g"), P("Nutrition Laddoo", "🧁", "Recipe", "no", "rate", { recipe: LADDOO_SUBS }),
  P("Cook charge", "👩‍🍳", "Charges", "unit"), P("Making charge", "👨‍🍳", "Charges", "unit"),
];

const ORDER = [/rice/i, /dal|pulse/i, /soya/i, /egg/i, /^veg/i, /oil/i, /masala|salt|condiment/i, /fuel/i];
const rank = (it) => { const i = ORDER.findIndex((r) => r.test(it.key) || r.test(it.name)); return i < 0 ? 99 : i; };
export const defaultOrder = (items) => [...items].sort((a, b) => (a.group ? 1 : 0) - (b.group ? 1 : 0) || rank(a) - rank(b));

const FACTOR = { g: 1000, ml: 1000, kg: 1, l: 1, no: 1, unit: 1 };
export const PRICE_UNIT = { g: "kg", ml: "l", kg: "kg", l: "l", no: "piece", unit: "unit" };
export const toRate = (qty, unit, price) => Math.round((Number(qty || 0) * Number(price || 0) / FACTOR[unit]) * 10000) / 10000;

// Append items (+ optional recipe group) to a config. cells: {itemName: {classKey: {qty, rate, price}}}
export function addItems(c, list) {
  const items = [...c.items];
  const groups = [...(c.groups || [])];
  const taken = () => [...items.map((x) => x.key), ...groups.map((g) => g.key)];
  const added = [];
  const pushItem = (p, group) => {
    if (items.some((x) => x.name.toLowerCase() === p.name.toLowerCase() && (x.group || null) === (group || null))) return;
    const it = { key: slug(p.key || p.name, taken()), name: p.name, name_local: p.name_local || "", emoji: p.emoji || "🍽️",
      unit: p.unit || "g", grain: !!p.grain, category: p.category || "Other", cost_mode: p.cost_mode || "rate" };
    if (group) it.group = group;
    items.push(it); added.push([it, p]);
  };
  list.forEach((p) => {
    if (p.recipe) {
      let g = groups.find((x) => x.name.toLowerCase() === p.name.toLowerCase());
      if (!g) { g = { key: slug(p.key || p.name, taken()), name: p.name, name_local: p.name_local || "", emoji: p.emoji, piece_cost: p.piece_cost ?? null }; groups.push(g); }
      p.recipe.forEach((s) => pushItem(s, g.key));
    } else pushItem(p, p.groupKey);
  });
  const periods = c.periods.map((pp, i) => {
    if (i !== 0) return pp;
    const classes = { ...(pp.classes || {}) };
    added.forEach(([it, p]) => Object.entries(p.cells || {}).forEach(([ck, cell]) => {
      if (!c.classes.some((x) => x.key === ck)) return;
      const cr = { ...(classes[ck] || {}) };
      cr.items = { ...(cr.items || {}), [it.key]: cell };
      classes[ck] = cr;
    }));
    return { ...pp, classes };
  });
  return { ...c, items, groups, periods };
}
